import { forwardRef, memo, useMemo } from "react";
import { bool, number, string, object, node, oneOfType, arrayOf, func } from "prop-types";
import { BreakdownTableDepths } from "@repo/utils";
import Grid from "@material-ui/core/Grid";
import { DragHandleCell, VisibilityCell } from "../../cells";
import useStyle from "./Row.style";
import classnames from "classnames";
import { useEstimateEditorSettings } from "@tools";

export const Row = memo(forwardRef(({
  id,
  children,
  // useExpandCell,
  useVisibilityCell,
  useDragHandleCell,
  displayDragHandleCell = true,
  isFirstGroupRow,
  isLastGroupRow,
  className,
  style,
  presetClass,
  actionPresetClass,
  altBackground,
  // expandable,
  expanded,
  // noArrow,
  onExpand,
  expandOnClick,
  visible = true,
  onVisibilityToggle,
  actionTargetName,
  tableDepth,
  isHeader,
  // highlightCellText,
}, ref) => {
  const classes = useStyle();
  const { isPdfPrinterView } = useEstimateEditorSettings();
  
  const isSection = useMemo(() => (
    tableDepth === BreakdownTableDepths.SECTION
  ), [tableDepth]);

  return (
    <Grid
      id={id}
      ref={ref}
      item container
      role="row"
      wrap="nowrap"
      alignItems={isHeader ? "flex-end" : undefined}
      className={classnames(
        "hoverRow",
        presetClass,
        tableDepth >= 0 && `d${tableDepth}`,
        classes.row,
        altBackground && classes.altBackground,
        !visible && classes.rowOff,
        expanded && classes.rowSelected,
        isLastGroupRow && "bottom",
        isFirstGroupRow && "top",
        !presetClass && expanded && tableDepth && `preset-active-${tableDepth}`,
        !presetClass && !expanded && !isSection && "preset-row",
        !presetClass && isSection && "preset-sectionRow",
        className
      )}
      style={style}
      aria-selected={expanded}
      onClick={expandOnClick ? onExpand : undefined}
    >
      {
        !isPdfPrinterView && displayDragHandleCell &&
        <DragHandleCell
          isHeader={isHeader}
          displayHandle={!isHeader && useDragHandleCell}
          presetClass={actionPresetClass}
        />
      }
      {/*{*/}
      {/*  useExpandCell &&*/}
      {/*  <ExpandCell*/}
      {/*    isHeader={isHeader}*/}
      {/*    size={size}*/}
      {/*    tableDepth={tableDepth}*/}
      {/*    expandable={expandable}*/}
      {/*    expanded={expanded}*/}
      {/*    onExpand={!expandOnClick ? onExpand : undefined}*/}
      {/*    noArrow={noArrow}*/}
      {/*    textPresetClass={actionPresetClass}*/}
      {/*    highlightCellText={highlightCellText}*/}
      {/*  />*/}
      {/*}*/}
      { children }
      {
        !isPdfPrinterView && useVisibilityCell &&
        <VisibilityCell
          isHeader={isHeader}
          visible={visible}
          onVisibilityToggle={onVisibilityToggle}
          actionTargetName={actionTargetName}
          tableDepth={tableDepth}
          displayToggle={useVisibilityCell}
          presetClass={actionPresetClass}
        />
      }
    </Grid>
  );
}));

Row.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired,
  id: string,
  // useExpandCell: bool,
  useVisibilityCell: bool,
  hideDragHandle: bool,
  isLastGroupRow: bool,
  isFirstGroupRow: bool,
  expandOnClick: bool,
  style: object,
  className: string,
  presetClass: string,
  actionPresetClass: string,
  isHeader: bool,
  tableDepth: number,
  // highlightCellText: bool,
  altBackground: bool,
  expanded: bool,
  useDragHandleCell: bool,
  displayDragHandleCell: bool,
  // expandable: bool,
  // noArrow: bool,
  onExpand: func,
  visible: bool,
  onVisibilityToggle: func,
  actionTargetName: string,
};
